import { useState } from 'react';
import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import { GradientSection } from 'components/Layout/GradientSection';
import ReportSection from './Report';
import { OverallStatisticsPage } from './OverallStatisticsPage';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`statistics-tabpanel-${index}`}
      aria-labelledby={`statistics-tab-${index}`}
      {...other}>
      {value === index && children}
    </div>
  );
};

export const StatisticsPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <GradientSection>
        <Container sx={{ pt: 8, pb: 2 }}>
          <Typography variant='headlineLarge' color='text.primary' gutterBottom>
            Statistics
          </Typography>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={selectedTab} onChange={handleTabChange} aria-label='statistics tabs'>
              <Tab label='Overall Statistics' id='statistics-tab-0' aria-controls='statistics-tabpanel-0' />
              <Tab label='Report Generator' id='statistics-tab-1' aria-controls='statistics-tabpanel-1' />
            </Tabs>
          </Box>
        </Container>
      </GradientSection>

      <TabPanel value={selectedTab} index={0}>
        <OverallStatisticsPage />
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <ReportSection />
      </TabPanel>
    </>
  );
};
